import { ArrowLeftOutlined } from "@ant-design/icons";
import { UiButton, UiProfileModel, UiRangePicker, UiSearch, UiSelect, UiTab, UiTable, UiWarningRating } from "../../components";
import { lang_en_US as translation } from "../../config";
import { formatPhoneNumber, tablePageSizeOptions } from "../../utils/appUtils";
import { DatePicker } from "antd";
import { downloadReport, userIcon } from "../../assets/images";
import { complaintesCustomerTabData } from "../../pages/main/customer/config";
import dayjs from "dayjs";
import { complaintesTabData, COMPLAINTS_HEADER_COLUMNS, complaintStatus } from "./config";

const Complaints = ({
    handleDateChange,
    handlePagination,
    complaintActionRender,
    handleComplaintTabChange,
    complaintsFilter,
    handleComplaintsCancel,
    handleSearch,
    handleMonthChange,
    handleComplaintStatus,
    complaintsResponseData,
    allComplaints,
    handleAllComplaintReport,
    handleComplaintAction
}) => {
    const keywords = translation?.lawyerManagement;
    const lawyerInformation = complaintsResponseData?.lawyerResponse;
    const customerInformation = complaintsResponseData?.customerResponse;
    return <>
        <div className="flexible">
            <div style={{ display: "flex", gap: "10px" }}>
                <ArrowLeftOutlined onClick={handleComplaintsCancel} />
                <h6 style={{ padding: "10px", margin: 0 }}>Complaints</h6>
            </div>
            <div className="flexible">
                <UiSelect allowClear={false} value={complaintsFilter?.complaintStatus} style={{ width: "120px" }} options={complaintStatus} onChange={(status) => handleComplaintStatus(status)} />
                <DatePicker value={complaintsFilter?.month || null} onChange={(month) => handleMonthChange(month, "complaints")} picker="month" format="MMM" placeholder="Select Month" style={{ height: 32, width: 150, borderRadius: 6 }} disabledDate={(current) => current && current > dayjs().endOf("day")} />
                <UiRangePicker value={complaintsFilter?.fromDate && complaintsFilter?.toDate ? [dayjs(complaintsFilter?.fromDate), dayjs(complaintsFilter?.toDate)] : null} onChange={(date) => handleDateChange(date, "complaints")} disabledDate={(current) => current && current > dayjs().endOf("day")} />
                <UiSearch value={complaintsFilter?.searchFilter} onChange={(search) => handleSearch(search?.target?.value, "complaints")} placeholder={keywords?.complaintSearchPlaceholder} />
                {
                    !complaintsFilter?.isCustomer && <UiButton type="primary" onClick={handleAllComplaintReport}><img src={downloadReport} alt="" /> Download Report</UiButton>
                }
            </div>
        </div>
        <div className="flexible" style={{ backgroundColor: "#005D600F", paddingTop: "10px" }}>
            <div className="flexible">
                {
                    !complaintsResponseData?.lawyerProfile || complaintsResponseData?.lawyerProfile?.includes("null") || complaintsResponseData?.lawyerProfile?.includes("undefined") ? <img src={userIcon} style={{ width: "50px", height: "50px", borderRadius: "50%", objectFit: "cover" }} alt="" /> : <UiProfileModel imageUrl={complaintsResponseData?.lawyerProfile} />
                }
                <div >
                    {
                        complaintsFilter?.isCustomer ? <div>
                            <h4 className="lawerInfo-detail">{customerInformation?.salutation || ""} {customerInformation?.firstName || ""} {customerInformation?.middleName || ""} {customerInformation?.lastName || ""}</h4>
                            <div style={{ padding: "5px 10px" }}>
                                <UiWarningRating count={customerInformation?.warningCountAfterActive} />
                            </div>
                        </div> : <div>
                            <h4 className="lawerInfo-detail">{lawyerInformation?.salutation || ""} {lawyerInformation?.firstName || ""} {lawyerInformation?.middleName || ""} {lawyerInformation?.lastName || ""}</h4>
                            <div style={{ padding: "5px 10px" }}>
                                <UiWarningRating count={lawyerInformation?.warningCountAfterActive} />
                            </div>
                        </div>
                    }
                </div>
            </div>
            {
                complaintsFilter?.isCustomer ? <div style={{ display: "flex", justifyContent: "space-between", width: "50%", paddingTop: "5px" }}>
                    <div>
                        <small className="information-header">Mobile Number</small>
                        <h4 className="lawerInfo-detail">{formatPhoneNumber(customerInformation?.mobileNumber) || "Nil"}</h4>
                    </div>
                    <div>
                        <small className="information-header">E-mail Address</small>
                        <h4 className="lawerInfo-detail">{customerInformation?.email || "Nil"}</h4>
                    </div>
                </div> : <div style={{ display: "flex", justifyContent: "space-between", width: "50%", paddingTop: "5px" }}>
                    <div>
                        <small className="information-header">Bar Council ID</small>
                        <h4 className="lawerInfo-detail">{lawyerInformation?.barCouncilId || "Nil"}</h4>
                    </div>
                    <div>
                        <small className="information-header">Advocate ID</small>
                        <h4 className="lawerInfo-detail">{lawyerInformation?.lawyerNo || "Nil"}</h4>
                    </div>
                    <div>
                        <small className="information-header">Mobile Number</small>
                        <h4 className="lawerInfo-detail">{formatPhoneNumber(lawyerInformation?.mobileNumber) || "Nil"}</h4>
                    </div>
                    <div>
                        <small className="information-header">E-mail Address</small>
                        <h4 className="lawerInfo-detail">{lawyerInformation?.email || "Nil"}</h4>
                    </div>
                </div>
            }

            <div>
                <h2 style={{ padding: 0, margin: 0, color: "#F1C40F" }}> Total Warning</h2>
                {
                    complaintsFilter?.isCustomer ? <p style={{ textAlign: "end", padding: 0, margin: 0, color: "#F1C40F" }}>{customerInformation?.totalWarningCount || "Nil"}</p> : <p style={{ textAlign: "end", padding: 0, margin: 0, color: "#F1C40F" }}>{lawyerInformation?.totalWarningCount || "Nil"}</p>
                }
            </div>
        </div>
        <>
            <UiTab tabs={complaintsFilter?.isCustomer ? complaintesCustomerTabData : complaintesTabData} count={complaintsFilter?.activeTab === "support" 
                ? allComplaints?.result?.supportDetailsResponse?.supportResponsePage?.totalElements 
                : allComplaints?.result?.lawyerComplaintDetails?.complaintResponsePage?.totalElements} onChange={handleComplaintTabChange} activeTabKey={complaintsFilter?.activeTabKey} />
            <UiTable
                dataSource={complaintsResponseData?.complaintsData}
                scroll={{ x: 'max-content' }}
                columns={COMPLAINTS_HEADER_COLUMNS({ complaintActionRender, activeTab: complaintsFilter?.activeTab, complaintStatus: complaintsFilter?.complaintStatus,handleComplaintAction })}
                pagination={complaintsFilter?.isAllComplaintReportOpen ? false : {
                    pageSize: complaintsFilter?.size,
                    current: complaintsFilter?.page + 1,
                    pageSizeOptions: tablePageSizeOptions,
                    showSizeChanger: true,
                    onChange: (page, size) => handlePagination(page, size, "complaints")
                }}
            />
        </>
    </>
};
export default Complaints